export enum OptionalAssets {
  Forex = 'forex',
  Futures = 'futures',
  DayTrade = 'dayTrade',
  Swing = 'swing',
  QuickBuy = 'quickBuy',
}
